import styled from 'styled-components';

export const Root = styled.div`
    font-family: ${props => props.brand === 'Lexus' && 'NobelWGL'};
    box-sizing: border-box;
`;
